module.exports = __webpack_public_path__ + "img/titrolue.385a2396.png";